export default __webpack_public_path__ + "static/8_Screenshot-8bb5a72987ce57e3980ac4188dd5feb8.png";